"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signaturePut = exports.signatureGet = exports.clientProductPut = exports.clientProductGet = exports.hoaStreetsDelete = exports.hoaStreetsPut = exports.hoaStreetsPost = exports.hoaStreetsGet = exports.hoaDelete = exports.hoaPut = exports.hoaPost = exports.hoaGet = exports.clientPut = exports.clientGet = void 0;
var axios_1 = __importDefault(require("axios"));
var company_json_1 = __importDefault(require("Utils/data/company.json"));
var hoa_json_1 = __importDefault(require("Utils/data/hoa.json"));
var hoaStreets_json_1 = __importDefault(require("Utils/data/hoaStreets.json"));
var products_json_1 = __importDefault(require("Utils/data/products.json"));
var companyData = company_json_1.default.item;
var clientId = companyData.ClientId;
var hoaData = hoa_json_1.default.item;
var hoaStreetsData = hoaStreets_json_1.default.item;
var productsData = products_json_1.default.item;
exports.clientGet = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/client/" + clientId)];
            case 1:
                res = _a.sent();
                console.log({ res: res }, "axios - function - clientGet");
                return [2];
        }
    });
}); };
exports.clientPut = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                completeData = { item: Object.assign(companyData, data) };
                return [4, axios_1.default.put("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/client/" + clientId, completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res }, "axios - function - clientPut");
                return [2];
        }
    });
}); };
exports.hoaGet = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/hoa?ManagementCompanyId=" + clientId)];
            case 1:
                res = _a.sent();
                console.log({ res: res }, "axios - function - hoaGet");
                response = res.data.result.length > 0
                    ? res.data.result.map(function (hoa) {
                        return {
                            HoaId: hoa.HoaId,
                            id: hoa.HoaId,
                            Name: hoa.Name,
                            State: hoa.State,
                            City: hoa.City,
                            zip: hoa.zip
                        };
                    })
                    : [];
                return [2, response];
        }
    });
}); };
exports.hoaPost = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                completeData = { item: Object.assign(hoaData, data) };
                return [4, axios_1.default.post("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/hoa", completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res, completeData: completeData, data: data }, "axios - function - hoaPost");
                return [2, res];
        }
    });
}); };
exports.hoaPut = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var hoaId, completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hoaId = data.HoaId;
                completeData = { item: Object.assign(hoaData, data) };
                return [4, axios_1.default.put("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/hoa/" + hoaId, completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res, completeData: completeData, data: data }, "axios - function - hoaPost");
                return [2, res];
        }
    });
}); };
exports.hoaDelete = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.delete("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/hoa/" + data)];
            case 1:
                res = _a.sent();
                console.log({ res: res, data: data }, "axios - function - hoaDelete");
                return [2, res];
        }
    });
}); };
exports.hoaStreetsGet = function (hoaId) { return __awaiter(void 0, void 0, void 0, function () {
    var res, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/street?HoaId=" + hoaId)];
            case 1:
                res = _a.sent();
                console.log({ res: res }, "axios - function - hoaStreetsGet");
                response = res.data.result.length > 0
                    ? res.data.result.map(function (hoa) {
                        return {
                            HoaId: hoa.HoaId,
                            StreetId: hoa.StreetId,
                            id: hoa.StreetId,
                            Street: hoa.Street,
                            State: hoa.State,
                            City: hoa.City,
                            Zip: hoa.Zip
                        };
                    })
                    : [];
                return [2, response];
        }
    });
}); };
exports.hoaStreetsPost = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                completeData = { item: Object.assign(hoaStreetsData, data) };
                return [4, axios_1.default.post("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/street", completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res, completeData: completeData, data: data }, "axios - function - hoaStreetsPost");
                return [2, res];
        }
    });
}); };
exports.hoaStreetsPut = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var hoaStreetId, completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                hoaStreetId = data.StreetId;
                completeData = { item: Object.assign(hoaStreetsData, data) };
                return [4, axios_1.default.put("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/street/" + hoaStreetId, completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res, completeData: completeData, data: data }, "axios - function - hoaStreetsPost");
                return [2, res];
        }
    });
}); };
exports.hoaStreetsDelete = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.delete("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/street/" + data)];
            case 1:
                res = _a.sent();
                console.log({ res: res, data: data }, "axios - function - hoaStreetsDelete");
                return [2, res];
        }
    });
}); };
exports.clientProductGet = function () { return __awaiter(void 0, void 0, void 0, function () {
    var dictonary, res, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dictonary = {
                    "40": "Escrow/Closing Demand Statement",
                    "26": "HOA Lender Questionnaire",
                    "117": "Resale Certificate/Governing Documents",
                    "4166": "Final Inspection"
                };
                return [4, axios_1.default.get("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/ClientProduct?ClientId=" + clientId)];
            case 1:
                res = _a.sent();
                console.log({ res: res }, "axios - function - clientProductGet");
                response = res.data.result.length > 0
                    ? res.data.result.map(function (product) {
                        return {
                            ClientId: product.ClientId,
                            ClientProductId: product.ClientProductId,
                            ProductId: product.ProductId,
                            id: product.ClientProductId,
                            Name: dictonary["" + product.ProductId],
                            GdnPrice: product.GdnPrice
                        };
                    })
                    : [];
                return [2, response];
        }
    });
}); };
exports.clientProductPut = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var clientProductId, completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                clientProductId = data.ClientProductId;
                completeData = { item: Object.assign(productsData, data) };
                return [4, axios_1.default.put("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/ClientProduct/" + clientProductId, completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res, completeData: completeData, data: data }, "axios - function - clientProductPut");
                return [2, res];
        }
    });
}); };
exports.signatureGet = function () { return __awaiter(void 0, void 0, void 0, function () {
    var dictonary, res, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dictonary = {
                    "40": "Escrow/Closing Demand Statement",
                    "26": "HOA Lender Questionnaire",
                    "117": "Resale Certificate/Governing Documents",
                    "4166": "Final Inspection"
                };
                return [4, axios_1.default.get("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/user/signature")];
            case 1:
                res = _a.sent();
                console.log({ res: res }, "axios - function - signatureGet");
                response = res.data.result.length > 0 ? res.data.result : [];
                return [2, response];
        }
    });
}); };
exports.signaturePut = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var completeData, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                completeData = { item: { signature: data } };
                return [4, axios_1.default.put("https://hwgaf1pax8.execute-api.us-west-2.amazonaws.com/dev/user/Signature", completeData, { headers: { "Content-Type": "application/json" } })];
            case 1:
                res = _a.sent();
                console.log({ res: res, completeData: completeData, data: data }, "axios - function - signaturePut");
                return [2, res];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvYXhpb3MvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQTBCO0FBQzFCLHlFQUE4QztBQUM5QyxpRUFBc0M7QUFDdEMsK0VBQW9EO0FBQ3BELDJFQUFnRDtBQUVoRCxJQUFNLFdBQVcsR0FBRyxzQkFBTyxDQUFDLElBQUksQ0FBQztBQUNqQyxJQUFNLFFBQVEsR0FBRyxXQUFXLENBQUMsUUFBUSxDQUFDO0FBRXRDLElBQU0sT0FBTyxHQUFHLGtCQUFHLENBQUMsSUFBSSxDQUFDO0FBQ3pCLElBQU0sY0FBYyxHQUFHLHlCQUFVLENBQUMsSUFBSSxDQUFDO0FBRXZDLElBQU0sWUFBWSxHQUFHLHVCQUFRLENBQUMsSUFBSSxDQUFDO0FBR3RCLFFBQUEsU0FBUyxHQUFHOzs7O29CQUNYLFdBQU0sZUFBSyxDQUFDLEdBQUcsQ0FDekIsdUVBQXFFLFFBQVUsQ0FDaEYsRUFBQTs7Z0JBRkssR0FBRyxHQUFHLFNBRVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLEVBQUUsOEJBQThCLENBQUMsQ0FBQzs7OztLQUN0RCxDQUFDO0FBQ1csUUFBQSxTQUFTLEdBQUcsVUFBTyxJQUFROzs7OztnQkFFaEMsWUFBWSxHQUFHLEVBQUUsSUFBSSxFQUFFLE1BQU0sQ0FBQyxNQUFNLENBQUMsV0FBVyxFQUFFLElBQUksQ0FBQyxFQUFFLENBQUM7Z0JBRXBELFdBQU0sZUFBSyxDQUFDLEdBQUcsQ0FDekIsdUVBQXFFLFFBQVUsRUFDL0UsWUFBWSxFQUNaLEVBQUUsT0FBTyxFQUFFLEVBQUUsY0FBYyxFQUFFLGtCQUFrQixFQUFFLEVBQUUsQ0FDcEQsRUFBQTs7Z0JBSkssR0FBRyxHQUFHLFNBSVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLEVBQUUsOEJBQThCLENBQUMsQ0FBQzs7OztLQUN0RCxDQUFDO0FBR1csUUFBQSxNQUFNLEdBQUc7Ozs7b0JBQ1IsV0FBTSxlQUFLLENBQUMsR0FBRyxDQUN6Qix3RkFBc0YsUUFBVSxDQUNqRyxFQUFBOztnQkFGSyxHQUFHLEdBQUcsU0FFWDtnQkFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxLQUFBLEVBQUUsRUFBRSwyQkFBMkIsQ0FBQyxDQUFDO2dCQUM1QyxRQUFRLEdBQ1osR0FBRyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxHQUFHLENBQUM7b0JBQ3hCLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsVUFBQyxHQUFRO3dCQUMzQixPQUFPOzRCQUNMLEtBQUssRUFBRSxHQUFHLENBQUMsS0FBSzs0QkFDaEIsRUFBRSxFQUFFLEdBQUcsQ0FBQyxLQUFLOzRCQUNiLElBQUksRUFBRSxHQUFHLENBQUMsSUFBSTs0QkFDZCxLQUFLLEVBQUUsR0FBRyxDQUFDLEtBQUs7NEJBQ2hCLElBQUksRUFBRSxHQUFHLENBQUMsSUFBSTs0QkFDZCxHQUFHLEVBQUUsR0FBRyxDQUFDLEdBQUc7eUJBQ2IsQ0FBQztvQkFDSixDQUFDLENBQUM7b0JBQ0osQ0FBQyxDQUFDLEVBQUUsQ0FBQztnQkFDVCxXQUFPLFFBQVEsRUFBQzs7O0tBQ2pCLENBQUM7QUFDVyxRQUFBLE9BQU8sR0FBRyxVQUFPLElBQVM7Ozs7O2dCQUUvQixZQUFZLEdBQUcsRUFBRSxJQUFJLEVBQUUsTUFBTSxDQUFDLE1BQU0sQ0FBQyxPQUFPLEVBQUUsSUFBSSxDQUFDLEVBQUUsQ0FBQztnQkFFaEQsV0FBTSxlQUFLLENBQUMsSUFBSSxDQUMxQixnRUFBZ0UsRUFDaEUsWUFBWSxFQUNaLEVBQUUsT0FBTyxFQUFFLEVBQUUsY0FBYyxFQUFFLGtCQUFrQixFQUFFLEVBQUUsQ0FDcEQsRUFBQTs7Z0JBSkssR0FBRyxHQUFHLFNBSVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLFlBQVksY0FBQSxFQUFFLElBQUksTUFBQSxFQUFFLEVBQUUsNEJBQTRCLENBQUMsQ0FBQztnQkFFdkUsV0FBTyxHQUFHLEVBQUM7OztLQUNaLENBQUM7QUFDVyxRQUFBLE1BQU0sR0FBRyxVQUFPLElBQVM7Ozs7O2dCQUU5QixLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQztnQkFDbkIsWUFBWSxHQUFHLEVBQUUsSUFBSSxFQUFFLE1BQU0sQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxFQUFFLENBQUM7Z0JBRWhELFdBQU0sZUFBSyxDQUFDLEdBQUcsQ0FDekIsb0VBQWtFLEtBQU8sRUFDekUsWUFBWSxFQUNaLEVBQUUsT0FBTyxFQUFFLEVBQUUsY0FBYyxFQUFFLGtCQUFrQixFQUFFLEVBQUUsQ0FDcEQsRUFBQTs7Z0JBSkssR0FBRyxHQUFHLFNBSVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLFlBQVksY0FBQSxFQUFFLElBQUksTUFBQSxFQUFFLEVBQUUsNEJBQTRCLENBQUMsQ0FBQztnQkFFdkUsV0FBTyxHQUFHLEVBQUM7OztLQUNaLENBQUM7QUFDVyxRQUFBLFNBQVMsR0FBRyxVQUFPLElBQVM7Ozs7b0JBRzNCLFdBQU0sZUFBSyxDQUFDLE1BQU0sQ0FDNUIsb0VBQWtFLElBQU0sQ0FDekUsRUFBQTs7Z0JBRkssR0FBRyxHQUFHLFNBRVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLElBQUksTUFBQSxFQUFFLEVBQUUsOEJBQThCLENBQUMsQ0FBQztnQkFFM0QsV0FBTyxHQUFHLEVBQUM7OztLQUNaLENBQUM7QUFHVyxRQUFBLGFBQWEsR0FBRyxVQUFPLEtBQWE7Ozs7b0JBQ25DLFdBQU0sZUFBSyxDQUFDLEdBQUcsQ0FDekIsNkVBQTJFLEtBQU8sQ0FDbkYsRUFBQTs7Z0JBRkssR0FBRyxHQUFHLFNBRVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLEVBQUUsa0NBQWtDLENBQUMsQ0FBQztnQkFDbkQsUUFBUSxHQUNaLEdBQUcsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLE1BQU0sR0FBRyxDQUFDO29CQUN4QixDQUFDLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQUMsR0FBUTt3QkFDM0IsT0FBTzs0QkFDTCxLQUFLLEVBQUUsR0FBRyxDQUFDLEtBQUs7NEJBQ2hCLFFBQVEsRUFBRSxHQUFHLENBQUMsUUFBUTs0QkFDdEIsRUFBRSxFQUFFLEdBQUcsQ0FBQyxRQUFROzRCQUNoQixNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU07NEJBQ2xCLEtBQUssRUFBRSxHQUFHLENBQUMsS0FBSzs0QkFDaEIsSUFBSSxFQUFFLEdBQUcsQ0FBQyxJQUFJOzRCQUNkLEdBQUcsRUFBRSxHQUFHLENBQUMsR0FBRzt5QkFDYixDQUFDO29CQUNKLENBQUMsQ0FBQztvQkFDSixDQUFDLENBQUMsRUFBRSxDQUFDO2dCQUNULFdBQU8sUUFBUSxFQUFDOzs7S0FDakIsQ0FBQztBQUNXLFFBQUEsY0FBYyxHQUFHLFVBQU8sSUFBUzs7Ozs7Z0JBRXRDLFlBQVksR0FBRyxFQUFFLElBQUksRUFBRSxNQUFNLENBQUMsTUFBTSxDQUFDLGNBQWMsRUFBRSxJQUFJLENBQUMsRUFBRSxDQUFDO2dCQUV2RCxXQUFNLGVBQUssQ0FBQyxJQUFJLENBQzFCLG1FQUFtRSxFQUNuRSxZQUFZLEVBQ1osRUFBRSxPQUFPLEVBQUUsRUFBRSxjQUFjLEVBQUUsa0JBQWtCLEVBQUUsRUFBRSxDQUNwRCxFQUFBOztnQkFKSyxHQUFHLEdBQUcsU0FJWDtnQkFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxLQUFBLEVBQUUsWUFBWSxjQUFBLEVBQUUsSUFBSSxNQUFBLEVBQUUsRUFBRSxtQ0FBbUMsQ0FBQyxDQUFDO2dCQUU5RSxXQUFPLEdBQUcsRUFBQzs7O0tBQ1osQ0FBQztBQUNXLFFBQUEsYUFBYSxHQUFHLFVBQU8sSUFBUzs7Ozs7Z0JBRXJDLFdBQVcsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDO2dCQUM1QixZQUFZLEdBQUcsRUFBRSxJQUFJLEVBQUUsTUFBTSxDQUFDLE1BQU0sQ0FBQyxjQUFjLEVBQUUsSUFBSSxDQUFDLEVBQUUsQ0FBQztnQkFFdkQsV0FBTSxlQUFLLENBQUMsR0FBRyxDQUN6Qix1RUFBcUUsV0FBYSxFQUNsRixZQUFZLEVBQ1osRUFBRSxPQUFPLEVBQUUsRUFBRSxjQUFjLEVBQUUsa0JBQWtCLEVBQUUsRUFBRSxDQUNwRCxFQUFBOztnQkFKSyxHQUFHLEdBQUcsU0FJWDtnQkFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxLQUFBLEVBQUUsWUFBWSxjQUFBLEVBQUUsSUFBSSxNQUFBLEVBQUUsRUFBRSxtQ0FBbUMsQ0FBQyxDQUFDO2dCQUU5RSxXQUFPLEdBQUcsRUFBQzs7O0tBQ1osQ0FBQztBQUNXLFFBQUEsZ0JBQWdCLEdBQUcsVUFBTyxJQUFTOzs7O29CQUdsQyxXQUFNLGVBQUssQ0FBQyxNQUFNLENBQzVCLHVFQUFxRSxJQUFNLENBQzVFLEVBQUE7O2dCQUZLLEdBQUcsR0FBRyxTQUVYO2dCQUNELE9BQU8sQ0FBQyxHQUFHLENBQUMsRUFBRSxHQUFHLEtBQUEsRUFBRSxJQUFJLE1BQUEsRUFBRSxFQUFFLHFDQUFxQyxDQUFDLENBQUM7Z0JBRWxFLFdBQU8sR0FBRyxFQUFDOzs7S0FDWixDQUFDO0FBR1csUUFBQSxnQkFBZ0IsR0FBRzs7Ozs7Z0JBQ3hCLFNBQVMsR0FBOEI7b0JBQzNDLElBQUksRUFBRSxpQ0FBaUM7b0JBQ3ZDLElBQUksRUFBRSwwQkFBMEI7b0JBQ2hDLEtBQUssRUFBRSx3Q0FBd0M7b0JBQy9DLE1BQU0sRUFBRSxrQkFBa0I7aUJBQzNCLENBQUM7Z0JBQ1UsV0FBTSxlQUFLLENBQUMsR0FBRyxDQUN6Qix1RkFBcUYsUUFBVSxDQUNoRyxFQUFBOztnQkFGSyxHQUFHLEdBQUcsU0FFWDtnQkFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxLQUFBLEVBQUUsRUFBRSxxQ0FBcUMsQ0FBQyxDQUFDO2dCQUN0RCxRQUFRLEdBQ1osR0FBRyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxHQUFHLENBQUM7b0JBQ3hCLENBQUMsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQ2pCLFVBQUMsT0FBa0Q7d0JBQ2pELE9BQU87NEJBQ0wsUUFBUSxFQUFFLE9BQU8sQ0FBQyxRQUFROzRCQUMxQixlQUFlLEVBQUUsT0FBTyxDQUFDLGVBQWU7NEJBQ3hDLFNBQVMsRUFBRSxPQUFPLENBQUMsU0FBUzs0QkFDNUIsRUFBRSxFQUFFLE9BQU8sQ0FBQyxlQUFlOzRCQUMzQixJQUFJLEVBQUUsU0FBUyxDQUFDLEtBQUcsT0FBTyxDQUFDLFNBQVcsQ0FBQzs0QkFDdkMsUUFBUSxFQUFFLE9BQU8sQ0FBQyxRQUFRO3lCQUMzQixDQUFDO29CQUNKLENBQUMsQ0FDRjtvQkFDSCxDQUFDLENBQUMsRUFBRSxDQUFDO2dCQUNULFdBQU8sUUFBUSxFQUFDOzs7S0FDakIsQ0FBQztBQUNXLFFBQUEsZ0JBQWdCLEdBQUcsVUFBTyxJQUFTOzs7OztnQkFFeEMsZUFBZSxHQUFHLElBQUksQ0FBQyxlQUFlLENBQUM7Z0JBQ3ZDLFlBQVksR0FBRyxFQUFFLElBQUksRUFBRSxNQUFNLENBQUMsTUFBTSxDQUFDLFlBQVksRUFBRSxJQUFJLENBQUMsRUFBRSxDQUFDO2dCQUVyRCxXQUFNLGVBQUssQ0FBQyxHQUFHLENBQ3pCLDhFQUE0RSxlQUFpQixFQUM3RixZQUFZLEVBQ1osRUFBRSxPQUFPLEVBQUUsRUFBRSxjQUFjLEVBQUUsa0JBQWtCLEVBQUUsRUFBRSxDQUNwRCxFQUFBOztnQkFKSyxHQUFHLEdBQUcsU0FJWDtnQkFDRCxPQUFPLENBQUMsR0FBRyxDQUNULEVBQUUsR0FBRyxLQUFBLEVBQUUsWUFBWSxjQUFBLEVBQUUsSUFBSSxNQUFBLEVBQUUsRUFDM0IscUNBQXFDLENBQ3RDLENBQUM7Z0JBRUYsV0FBTyxHQUFHLEVBQUM7OztLQUNaLENBQUM7QUFHVyxRQUFBLFlBQVksR0FBRzs7Ozs7Z0JBQ3BCLFNBQVMsR0FBOEI7b0JBQzNDLElBQUksRUFBRSxpQ0FBaUM7b0JBQ3ZDLElBQUksRUFBRSwwQkFBMEI7b0JBQ2hDLEtBQUssRUFBRSx3Q0FBd0M7b0JBQy9DLE1BQU0sRUFBRSxrQkFBa0I7aUJBQzNCLENBQUM7Z0JBQ1UsV0FBTSxlQUFLLENBQUMsR0FBRyxDQUN6QiwyRUFBMkUsQ0FDNUUsRUFBQTs7Z0JBRkssR0FBRyxHQUFHLFNBRVg7Z0JBQ0QsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFLEdBQUcsS0FBQSxFQUFFLEVBQUUsaUNBQWlDLENBQUMsQ0FBQztnQkFDbEQsUUFBUSxHQUFVLEdBQUcsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUM7Z0JBQzFFLFdBQU8sUUFBUSxFQUFDOzs7S0FDakIsQ0FBQztBQUNXLFFBQUEsWUFBWSxHQUFHLFVBQU8sSUFBUzs7Ozs7Z0JBQ3BDLFlBQVksR0FBRyxFQUFFLElBQUksRUFBRSxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsRUFBRSxDQUFDO2dCQUV2QyxXQUFNLGVBQUssQ0FBQyxHQUFHLENBQ3pCLDJFQUEyRSxFQUMzRSxZQUFZLEVBQ1osRUFBRSxPQUFPLEVBQUUsRUFBRSxjQUFjLEVBQUUsa0JBQWtCLEVBQUUsRUFBRSxDQUNwRCxFQUFBOztnQkFKSyxHQUFHLEdBQUcsU0FJWDtnQkFDRCxPQUFPLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxLQUFBLEVBQUUsWUFBWSxjQUFBLEVBQUUsSUFBSSxNQUFBLEVBQUUsRUFBRSxpQ0FBaUMsQ0FBQyxDQUFDO2dCQUU1RSxXQUFPLEdBQUcsRUFBQzs7O0tBQ1osQ0FBQyJ9